import { render, staticRenderFns } from "./mHome.vue?vue&type=template&id=f821d3b2&scoped=true&"
import script from "./mHome.vue?vue&type=script&lang=js&"
export * from "./mHome.vue?vue&type=script&lang=js&"
import style0 from "./mHome.vue?vue&type=style&index=0&id=f821d3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f821d3b2",
  null
  
)

export default component.exports